module.exports = __webpack_public_path__ + "static/media/Wardrobes (7).8e99b26d.jpg";